import { Controller } from "stimulus";
import { submitForm } from "init/ajax";

export default class extends Controller {
  connect() {
    this.formPassword = this.element.querySelector('.form__password');
    this.mask = this.element.querySelector(".btn--mask");
  }

  showCreateAccountModal(event) {
    event.preventDefault()

    document
      .querySelector('.js-CreateAccountModal__section')
      .classList
      .add('CreateAccountModal__reveal')
  }

  async submit(event) {
    event.preventDefault()

    document.querySelector(".account-login").classList.remove('open');

    const form = event.currentTarget;
    // Consider everything valid if browser validations aren't supported
    if (!form.reportValidity || form.reportValidity()) {
      let responseHTML = await submitForm(form);

      let createAccountModalElement = responseHTML.querySelector('.CreateAccountModal__section')
      let pendingConfirmationModalElement = responseHTML.querySelector('.js-PendingConfirmation__modal')
      let signInModalElement = responseHTML.querySelector('.SignIn__modal')

      if (signInModalElement) {
        this.element.replaceWith(signInModalElement)
      } else if (createAccountModalElement) {
        this.element.replaceWith(createAccountModalElement)
      } else if (pendingConfirmationModalElement) {
        this.element.replaceWith(pendingConfirmationModalElement)
      }
    }
  }

  togglePassword() {
    if (this.formPassword.type === 'password') {
      this.formPassword.type = 'text'
      this.mask.classList.add('is-unmasked');
    }
    else {
      this.formPassword.type = 'password'
      this.mask.classList.remove('is-unmasked');
    }
  }
}
